/**
 * Owner account provisioning API — 11F.3 / D9.
 *
 * Owners are not staff (no per-tenant Firestore doc) — this hits a
 * dedicated endpoint, not the staff API. Only an existing owner may call
 * POST /v1/auth/owners; the backend enforces this (403 insufficient_role),
 * this client makes no assumptions about who's allowed to call it.
 */

import { useMutation } from '@tanstack/react-query';
import { api } from '@core/api/client';

export interface OwnerAccountCreate {
  email: string;
  display_name: string;
  tenant_ids: string[];
  temporary_password?: string | null;
}

export interface OwnerAccountResponse {
  uid: string;
  email: string;
  display_name: string;
  role: 'owner';
  tenant_ids: string[];
  action: 'created' | 'promoted';
  generated_password?: string | null;
}

export async function createOwnerAccount(
  body: OwnerAccountCreate,
): Promise<OwnerAccountResponse> {
  return api.post<OwnerAccountResponse>('/v1/auth/owners', body);
}

export function useCreateOwnerAccount() {
  return useMutation({ mutationFn: createOwnerAccount });
}
